export default "__VITE_ASSET__DUAMxF4Y__"